import { useCallback } from 'react';
import { useToken } from 'store/hooks/useToken';
import { useActiveDirectoryLoginMutation, useLoginMutation } from '../../api/auth';
import Login from './Login';

const LoginContainer = props => {
  const loginMutation = useLoginMutation();
  const activeDirectoryMutation = useActiveDirectoryLoginMutation();
  const { mutate: mutateLogin, reset: resetLogin } = loginMutation;
  const { mutate: mutateActiveDirectory, reset: resetActiveDirectory } = activeDirectoryMutation;
  const token = useToken();
  const login = useCallback(
    (email, password) => {
      resetActiveDirectory();
      mutateLogin({ username: email, password });
    },
    [resetActiveDirectory, mutateLogin]
  );
  const activeDirectory = useCallback(
    adToken => {
      resetLogin();
      mutateActiveDirectory(adToken);
    },
    [resetLogin, mutateActiveDirectory]
  );

  return (
    <Login
      {...props}
      error={loginMutation.error?.message || activeDirectoryMutation.error?.message}
      isLoading={loginMutation.isPending || activeDirectoryMutation.isPending}
      token={token}
      login={login}
      activeDirectory={activeDirectory}
    />
  );
};

export default LoginContainer;
